import React from 'react'

const SvgWalletFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 6.626v12.89a2 2 0 002 2h14a2 2 0 002-2v-2.337a3.5 3.5 0 000-6.326V8.516a2 2 0 00-2-2H2.002a2.02 2.02 0 00-.002.11zm16.5 5.89h-2a1.5 1.5 0 000 3h2a1.5 1.5 0 000-3z'
    />
    <path d='M18 4a2 2 0 00-2.428-1.953l-12 2.625H18v-.671z' />
  </svg>
)

export default SvgWalletFilled
